export const endpoints = {
  LOGIN: "/api/auth/login",
}
